import { FC } from 'react';
import { Col } from 'reactstrap';
import { CommunityPartnerPartner } from 'Types';
import { ShimmerImage } from 'Elements';
import styles from 'partials/homepage/card/partner-card.module.scss';

interface Props {
	partner: CommunityPartnerPartner;
}

export const CommunityPartnerPartnerCard: FC<Props> = ({ partner }) => {
	const companyName = partner?.businessName;
	const defaultLogo = '/assets/img/business-partner-default.png';

	return (
		<Col sm={6} md={4} lg={3} className="mb-4">
			<article className={styles.card}>
				<div className={styles.logoWrapper}>
					<ShimmerImage
						width={500}
						height={200}
						src={partner?.logo?.thumbnail || defaultLogo}
						defaultImage={defaultLogo}
						alt={companyName}
						className={styles.logo}
					/>
				</div>
				<div className="position-relative d-flex flex-column align-items-center text-center px-2 pb-4 gap-2 w-100 mt-auto">
					<h4 className="fs-6 fw-bold lh-base mb-0">{companyName}</h4>
					{/* {setting?.branch && (
						<span className="fw-light">{setting?.branch}</span>
					)} */}
				</div>
			</article>
		</Col>
	);
};
